import React, { useState, useEffect } from 'react'
import Wrapper from '../../Main/Universal/Wrapper'
import Swal from 'sweetalert2'
import { postAPI } from '../../../app/api'
import NoticeManagement from './NoticeManagement'
import NoticeCategoryManagement from './NoticeCategoryManagement'

export default function Notice() {
    return (
        <>
        <Wrapper>
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="notice-tab" data-bs-toggle="tab" data-bs-target="#notice" type="button" role="tab" aria-controls="notice" aria-selected="true">Notice</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="category-tab" data-bs-toggle="tab" data-bs-target="#category" type="button" role="tab" aria-controls="category" aria-selected="false">Category</button>
                </li>
            </ul>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="notice" role="tabpanel" aria-labelledby="notice-tab">
                    <NoticeManagement />
                </div>
                <div class="tab-pane fade" id="category" role="tabpanel" aria-labelledby="category-tab">
                    <NoticeCategoryManagement />
                </div>
            </div>
            </Wrapper>
        </>
    )
}
